<template>
    <div
        ref="image"
        class="rounded-card-md relative h-full w-full overflow-hidden"
        :class="{
            'min-h-[250px]': block.Height === 'auto',
        }"
        :style="customHeight"
    >
        <Image
            :image="imageSize"
            class="absolute! inset-0"
        />
    </div>
</template>

<script setup>
    const props = defineProps({
        block: Object,
    })

    const image = ref(null)

    const customHeight = computed(() => {
        if (props.block?.Height !== 'custom') {
            return ''
        }

        return {
            height: `${props.block?.CustomHeight}px`,
        }
    })

    // Computed property to dynamically determine the image URL
    const imageSize = computed(() => {
        const image = props.block?.Image[0]
        if (!image) return null
        return image.width < 1920 ? props.block?.ImageOriginal : props.block?.Image
    })
</script>
